import styled from '@emotion/styled';
import theme from '../../themes/default';

export const ChipsWrapper = styled('section')`
  > :not(:last-child) {
    margin-right: ${theme.spacing.xSmall};
  }
`;
